import { PatientFormScreen } from "~/session/patient-form/patient-form-screen";

// /session/:id/patient/:patientId/edit — edit a patient's handover entry (E4.1).
// Editable only by the session's outgoing doctor while the session is unlocked
// and the patient is unacknowledged; otherwise the shared screen renders 404 or
// a read-only, locked view.
export default function EditPatientRoute(): JSX.Element {
  return <PatientFormScreen mode="edit" />;
}
